import { render, staticRenderFns } from "./ListFolder.vue?vue&type=template&id=20a6ecce&scoped=true&"
import script from "./ListFolder.vue?vue&type=script&lang=js&"
export * from "./ListFolder.vue?vue&type=script&lang=js&"
import style0 from "./ListFolder.vue?vue&type=style&index=0&id=20a6ecce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a6ecce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
